import { BaseClient } from '@/api'

export class CompanyDynamicClient extends BaseClient {
  constructor(
  ) {
    super('company-dynamics')
  }
}
